import {FC} from 'react';
import {PromoCard} from '@components/PromoCard';
import {Typography} from '@components/Typography';
import {FormattedMessage, FormattedNumber} from 'react-intl';
import {getMortageData} from '@utils/mortage';
import {Currency} from '.cache/__types__';

type MortgagePromoCardProps = {
    price: number;
    percentageRate: number;
    currency: Currency;
};

export const MortgagePromoCard: FC<MortgagePromoCardProps> = ({price, percentageRate, currency}) => {
    const {repayment, rate} = getMortageData(price, percentageRate);

    return (
        <PromoCard variant="green" size="sm" className="d-none d-xxl-flex">
            <PromoCard.Title>
                <FormattedMessage defaultMessage="Potřebujete hypotéku?" />
            </PromoCard.Title>

            <PromoCard.Desc>
                <FormattedMessage
                    defaultMessage="Tato nemovitost již od <bold>{price}</bold> měsíčně s\u00a0roční úrokovou sazbou <bold>{rate}</bold>."
                    values={{
                        bold: (chunks: any) => (
                            <Typography variant="perex-lg" fontWeight="bold">
                                {chunks}
                            </Typography>
                        ),
                        price: <FormattedNumber style="currency" value={repayment} maximumFractionDigits={0} currency={currency} />,
                        rate: <FormattedNumber style="percent" value={rate} maximumFractionDigits={2} />,
                    }}
                />{' '}
            </PromoCard.Desc>

            <PromoCard.Link>
                <a href="https://hypoteka.bezrealitky.cz/">
                    <FormattedMessage defaultMessage="Porovnejte další nabídky" />
                </a>
            </PromoCard.Link>
        </PromoCard>
    );
};
